import styled from "styled-components";
import { RawButton } from "../../Styled/Button";
export const TourProgressDot = styled(RawButton).withConfig({
  displayName: "TourProgressDot",
  componentId: "sc-1brnhzi-0"
})(["display:inline-block;box-sizing:border-box;height:7px;width:7px;border:1px solid ", ";background-color:", ";margin-left:8px;border-radius:50%;"], p => p.theme.colorPrimary, p => p.active ? p.theme.colorPrimary : "transparent");
export default TourProgressDot;